import { useQuery } from '@tanstack/react-query';
import { TaskMaterial, TaskMaterialSummary } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';

export const TASK_MATERIALS_QUERY_KEY = ['taskMaterials'];

export const useTaskMaterials = (taskId: string | undefined) => {
  return useQuery<TaskMaterial[], Error>({
    queryKey: [...TASK_MATERIALS_QUERY_KEY, taskId],
    queryFn: async () => {
      if (!taskId) throw new Error('taskId is required');
      return await warehouseService.getTaskMaterials(taskId);
    },
    enabled: !!taskId,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};

export const useTaskMaterialSummary = (taskId: string | undefined) => {
  return useQuery<TaskMaterialSummary, Error>({
    queryKey: [...TASK_MATERIALS_QUERY_KEY, taskId, 'summary'],
    queryFn: async () => {
      if (!taskId) throw new Error('taskId is required');
      return await warehouseService.getTaskMaterialSummary(taskId);
    },
    enabled: !!taskId,
    staleTime: 2 * 60 * 1000,
  });
};
